export const horizontalResizeEventName = (resizableContainerName) => `event:${resizableContainerName}:resize`;
export const horizontalChangeWidthEventName = (resizableContainerName) => `event:${resizableContainerName}:change:width`;
